<ng-container *transloco="let t">
    <button
        [matMenuTriggerFor]="menu"
        (menuOpened)="menuOpened()"
        mat-stroked-button
        (click)="onClick()"
        [ngClass]="{ 'highlighted-stroked': addressDisplay != 'noAddress' }"
    >
        <ng-container [ngSwitch]="addressDisplay">
            <div *ngSwitchCase="'noAddress'">
                {{ t('filters.address.field-label') }}
            </div>
            <div *ngSwitchCase="'address'">{{ t('filters.address.address-selected') }} {{ address | truncate : 7 }}</div>
        </ng-container>
    </button>

    <mat-menu #menu="matMenu" class="address-filter-menu" (closed)="menuClosed()">
        <form [formGroup]="form" action="." (ngSubmit)="submit()">
            <div
                (click)="$event.stopPropagation()"
                (keydown.tab)="$event.stopPropagation()"
                (keydown.shift.tab)="$event.stopPropagation()"
                class="d-flex flex-column"
                cdkTrapFocus
                [cdkTrapFocusAutoCapture]="true"
            >
                <div class="p-4 d-flex flex-column">
                    <div class="pb-3">{{ t('filters.address.title') }}</div>
                    <mat-form-field class="w-100" appearance="standard">
                        <mat-label>{{ t('filters.address.field-label') }}</mat-label>
                        <input formControlName="addressFilter" autocapitalize="off" autocomplete="off" autocorrect="off" type="search" matInput #addressInput />
                        <mat-error>
                            <td-validation-messages
                                [control]="form.get('addressFilter')!"
                                [context]="{ name: t('filters.address.field-label') }"
                            ></td-validation-messages>
                        </mat-error>
                    </mat-form-field>
                </div>
                <mat-divider></mat-divider>
                <div class="p-3 d-flex justify-content-end align-items-end gap-4">
                    <button type="button" mat-stroked-button class="js-cancel-btn" (click)="clear()">{{ t('actions.clear') }}</button>
                    <button mat-flat-button color="primary" class="js-submit" [disabled]="isDisabled()" type="submit">{{ t('actions.filter') }}</button>
                </div>
            </div>
        </form>
    </mat-menu>
</ng-container>
